import { Component, OnInit } from '@angular/core';
import { ApiIntegration } from "../../_services/api.integration";
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { User } from '../../_models/user';
import { Router } from '@angular/router';
import { Globals } from '../../_models/globals';
import { Register } from '../../_models/register';
import { AlertService } from '../../_services/alert.service';

@Component({
  selector: 'app-create-account-owner-list',
  templateUrl: './create-account-owner-list.component.html',
  styleUrls: ['./create-account-owner-list.component.css']
})

export class CreateAccountOwnerListComponent implements OnInit {
  address1: string;
  address2: string;
  addressTypes: any = [];
  addressType: string;
  city: string;
  companyName: string;
  country: string;
  email: string;
  mobileNumber: string;
  name: string;
  state: string;
  zip: string;
  geoCode: string;
  statusText: string;
  password: string;
  reEnterPassword: string;
  errorMessage: string = "";
  passMessage: string = "";
  tabClicked = "address";
  citiesList: any;

  emailValidationMessage: string = "";
  phoneValidationMessage: string = "";
  mobileValidationMessage: string = "";
  passwordValidationMessage: string = "";
  statusText1: string = "";
  statusText2: string = "";
  statusText3: string = "";
  statusText4: string = "";
  statusText5: string = "";
  statusText6: string = "";
  statusText7: string = "";
  statusText8: string = "";
  statusText9: string = "";
  statusText10: string = "";
  statusText11: string = "";
  statusText12: string = "";
  statesList: any;

  constructor(private alertService: AlertService, public user: User, private http: HttpClient, private router: Router, private g: Globals, private api: ApiIntegration) {
    this.g.page = "Create Customer";
    this.api.getValues("1", "ADDRESS_TYPE", "ADDRESS_TYPE", "ADDRESS_TYPE").subscribe((data: any) => {
      this.addressTypes = data.tripleSetConfigDTOS;
    }, err => {
      this.alertService.error('Error', err);
    });
    this.stateList();
    this.cityList();
  }

  stateList() {
    this.api.getDistinctStates().subscribe((data: any) => {
      this.statesList = data;
    }, err => {
      this.alertService.error('Error', err);
    });
  }

  cityList() {
    this.api.getDistinctCity().subscribe((data: any) => {
      this.citiesList = data;
    }, err => {
      this.alertService.error('Error', err);
    });
  }

  changeStateAndCity() {
    this.api.getCityAndStateByPinCode(this.zip).subscribe((data: any) => {
      this.city = data.city;
      this.state = data.state;
    }, err => {
      this.alertService.error('Error', err);
    });
  }


  ngOnInit() {
  }

  typeCompanyName() {
    this.statusText1 = "";
    if (this.companyName == '' || this.companyName === null || this.companyName === undefined || this.companyName === 'undefined') {
      this.statusText1 = 'Please enter company name';
    }
  }

  typeContactName() {
    this.statusText2 = "";
    if (this.name == '' || this.name === null || this.name === undefined || this.name === 'undefined') {
      this.statusText2 = 'Please enter contact name';
    }
  }

  typePhoneNumber() {
    this.statusText3 = "";
    if (this.mobileNumber == '' || this.mobileNumber === null || this.mobileNumber === undefined || this.mobileNumber === 'undefined') {
      this.statusText3 = 'Please enter phone number';
    } else if (this.mobileNumber.length != 10) {
      this.statusText3 = 'phone number must be minimum 10 characters';
    }
  }

  typeValidateEmail() {
    this.statusText9 = "";
    if (this.email == '' || this.email === null || this.email === undefined || this.email === 'undefined') {
      this.statusText9 = 'Please enter email address';
    }
  }

  onCreatePassword() {
    this.statusText10 = "";
    if (this.password == '' || this.password === null || this.password === undefined || this.password === 'undefined') {
      this.statusText10 = 'Please enter password';
    } else if (this.password.length <= 5) {
      this.statusText10 = 'Password must be minimum 6 characters';
    }
  }

  onCreateReenterPassword() {
    this.statusText11 = "";
    if (this.reEnterPassword == '' || this.reEnterPassword === null || this.reEnterPassword === undefined || this.reEnterPassword === 'undefined') {
      this.statusText11 = 'Please enter password';
    } else if (this.password.length <= 5) {
      this.statusText11 = 'Password must be minimum 6 characters';
    }
  }

  selectAddressType() {
    this.statusText12 = "";
    if (this.addressType == '' || this.addressType === null || this.addressType === undefined || this.addressType === 'undefined') {
      this.statusText12 = 'Please select addressType';
    }
  }

  typeAddress() {
    this.statusText4 = "";
    if (this.address1 == '' || this.address1 === null || this.address1 === undefined || this.address1 === 'undefined') {
      this.statusText4 = 'Please enter address Line1';
    }
  }

  typeCity() {
    this.statusText6 = "";
    if (this.city == '' || this.city === null || this.city === undefined || this.city === 'undefined') {
      this.statusText6 = 'Please enter city';
    }
  }

  typeState() {
    this.statusText7 = "";
    if (this.state == '' || this.state === null || this.state === undefined || this.state === 'undefined') {
      this.statusText7 = 'Please enter state';
    }
  }

  zipCode() {
    this.statusText8 = "";
    if (this.zip == '' || this.zip === null || this.zip === undefined || this.zip === 'undefined') {
      this.statusText8 = 'Please enter zip Code';
    }
  }

  validateFields() {
  }

  submitRegistration() {
    this.passwordValidationMessage = "";
    if (this.emailValidationMessage == "" && this.mobileValidationMessage == "") {
      var header1 = new HttpHeaders();
      header1 = header1.append('Content-Type', 'application/json');
      header1 = header1.append('Accept', 'application/json');
      this.http.post(environment.apiUrl + 'api/generateOTP?PhoneNumber=' + this.mobileNumber + "&organizationId=" + this.user.organizationId,
        {
          headers: header1
        }).subscribe(data => {
        },
          (err: HttpErrorResponse) => {
            console.log(err);
          }
        )
    }
  }

  validateEmail() {
    //   this.emailValidationMessage = "";
    this.statusText9 = "";
    if (this.email === '') {
      this.statusText9 = 'Please enter email';
    }
    if (this.statusText9 != "") {
      return false;
    }
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    this.http.post(environment.apiUrl + 'api/uniqueEmail',
      this.email,
      { headers: header1 }).subscribe(data => {
        if (data['code'] == 200) {
        } else {
          var errorMessage = "invalid email";
          if (data['code'] == 400) {
            errorMessage = data['message'];
          }
          this.statusText9 = errorMessage;
        }
      },
        (err: HttpErrorResponse) => {
          console.log(err);
          this.statusText9 = "uniqueEmail Failed, please re-try.";
        }
      )
  }

  validatePhone() {
    this.mobileValidationMessage = "";
    this.statusText3 = "";
    if (this.mobileNumber.length === null) {
      this.statusText3 = 'Please enter phone number';
    }
    if (this.statusText3 != "") {
      return false;
    }
    let i = this.mobileNumber.indexOf('0');
    if (i == 0) {
      this.statusText3 = "Number should not start with 0";
      return false;
    }
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    this.http.post(environment.apiUrl + 'api/uniqueMobileNumber',
      this.mobileNumber,
      { headers: header1 }).subscribe(data => {
        if (data['code'] == 200) {

        } else {
          var errorMessage = "invalid phoneNumber";
          if (data['code'] == 400) {
            errorMessage = data['message'];
          }
          this.mobileValidationMessage = errorMessage;
        }

      },
        (err: HttpErrorResponse) => {
          console.log(err);
          this.mobileValidationMessage = "phone number  exists";
        }
      )
  }

  tabChange(tab) {
    this.tabClicked = tab
  }

  checkValidations() {
    this.statusText1 = "";
    this.statusText2 = "";
    this.statusText3 = "";
    this.statusText4 = "";
    this.statusText5 = "";
    this.statusText6 = "";
    this.statusText7 = "";
    this.statusText8 = "";
    this.statusText9 = "";
    this.statusText10 = "";
    this.statusText11 = "";
    this.statusText12 = "";

    if (this.companyName == '' || this.companyName === null || this.companyName === undefined || this.companyName === 'undefined') {
      this.statusText1 = 'Please enter company name';
    }
    if (this.name == '' || this.name === null || this.name === undefined || this.name === 'undefined') {
      this.statusText2 = 'Please enter contact name';
    }
    if (this.mobileNumber == '' || this.mobileNumber === null || this.mobileNumber === undefined || this.mobileNumber === 'undefined') {
      this.statusText3 = 'Please enter phone number';
    } else if (this.mobileNumber.length != 10) {
      this.statusText3 = 'phone number must be minimum 10 characters';
    }
    if (this.email == '' || this.email === null || this.email === undefined || this.email === 'undefined') {
      this.statusText9 = 'Please enter email address';
    }
    if (this.address1 == '' || this.address1 === null || this.address1 === undefined || this.address1 === 'undefined') {
      this.statusText4 = 'Please enter address1';
    }
 /*    if (this.address2 == '' || this.address2 === null || this.address2 === undefined || this.address2 === 'undefined') {
      this.statusText5 = 'Please enter address2';
    } */
    if (this.city == '' || this.city === null || this.city === undefined || this.city === 'undefined') {
      this.statusText6 = 'Please enter city';
    }
    if (this.state == '' || this.state === null || this.state === undefined || this.state === 'undefined') {
      this.statusText7 = 'Please enter state';
    }
    if (this.zip == '' || this.zip === null || this.zip === undefined || this.zip === 'undefined') {
      this.statusText8 = 'Please enter zip';
    } else if (this.zip.length != 6) {
      this.statusText8 = 'ZipCode must be minimum 6 characters';
    }

    if (this.statusText1 != "" || this.statusText2 != "" || this.statusText3 != "" || this.statusText4 != "" || this.statusText5 != "" || this.statusText6 != "" || this.statusText7 != "" || this.statusText8 != "" || this.statusText9 != "") {
      this.g.loaderDisplay = "";
      return false;
    }
    this.tabChange('warehouses');
  }

  submit() {
    this.g.loaderDisplay = "display";
    this.clearStatusText();
    this.statusText = "";
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    this.http.post(environment.apiUrl + 'api/registerCompany', {
      "address1": this.address1,
      "address2": this.address2,
      "addressType": "SHIPPING",
      "city": this.city,
      "companyName": this.companyName,
      "country": this.country,
      "email": this.email,
      "mobileNumber": this.mobileNumber,
      "name": this.name,
      "organizationId": 1,
      "password": "NOPASSWORD",
      "reEnterPassword": "NOPASSWORD",
      "state": this.state,
      "zip": this.zip,
      "geoCode": this.geoCode
    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('Customer', 'Created Successfully');

          this.router.navigate(['/admin/accountOwnerList']);
        } else {
          this.alertService.error('Error', "");
        }
        this.g.loaderDisplay = "";
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });
  }

  createCompanyName() {
    this.statusText1 = "";
    if (this.companyName == '' || this.companyName === null || this.companyName === undefined || this.companyName === 'undefined') {
      this.statusText1 = 'Please enter company name';
      return false;
    }
  }

  createContactName() {
    this.statusText2 = "";
    if (this.name == '' || this.name === null || this.name === undefined || this.name === 'undefined') {
      this.statusText2 = 'Please enter contact name';
      return false;
    }
  }

  createEmail() {
    this.statusText9 = "";
    if (this.email == '' || this.email === null || this.email === undefined || this.email === 'undefined') {
      this.statusText9 = 'Please enter email address';
      return false;
    }
  }

  createMobile() {
    this.statusText3 = "";
    if (this.mobileNumber == '' || this.mobileNumber === null || this.mobileNumber === undefined || this.mobileNumber === 'undefined') {
      this.statusText3 = 'Please enter phone number';
      return false;
    } else if (this.mobileNumber.length != 10) {
      this.statusText3 = 'phone number must be minimum 10 characters';
      return false;
    }
  }

  createPassword() {
    this.statusText10 = "";
    if (this.password == '' || this.password === null || this.password === undefined || this.password === 'undefined') {
      this.statusText10 = 'Please enter password';
      return false;
    } else if (this.password.length <= 5) {
      this.statusText10 = 'Password must be minimum 6 characters';
      return false;
    }
  }

  createReenterPassword() {
    this.statusText11 = "";
    if (this.reEnterPassword == '' || this.reEnterPassword === null || this.reEnterPassword === undefined || this.reEnterPassword === 'undefined') {
      this.statusText11 = 'Please enter password';
      return false;
    } else if (this.password.length <= 5) {
      this.statusText11 = 'Password must be minimum 6 characters';
      return false;
    }
  }

  createPasswordMatch() {
    this.statusText = "";
    if (this.statusText10 === "" && this.statusText11 === "") {
      if (this.password != this.reEnterPassword) {
        this.statusText = "Password does not match";
        return false;
      }
    }
  }

  createAddress() {
    this.statusText4 = "";
    if (this.address1 == '' || this.address1 === null || this.address1 === undefined || this.address1 === 'undefined') {
      this.statusText4 = 'Please enter address';
      return false;
    }
  }

  createAddress2() {
    this.statusText5 = "";
    if (this.address2 == '' || this.address2 === null || this.address2 === undefined || this.address2 === 'undefined') {
      this.statusText5 = 'Please enter address2';
      return false;
    }
  }

  createCity() {
    this.statusText6 = "";
    if (this.city == '' || this.city === null || this.city === undefined || this.city === 'undefined') {
      this.statusText6 = 'Please enter city';
      return false;
    }
  }

  createState() {
    this.statusText7 = "";
    if (this.state == '' || this.state === null || this.state === undefined || this.state === 'undefined') {
      this.statusText7 = 'Please enter state';
      return false;
    }
  }

  createZip() {
    this.statusText8 = "";
    if (this.zip == '' || this.zip === null || this.zip === undefined || this.zip === 'undefined') {
      this.statusText8 = 'Please enter zip';
      return false;
    } else if (this.zip.length != 6) {
      this.statusText8 = 'ZipCode must be minimum 6 characters';
      return false;
    }

  }

  clearStatusText() {
    this.statusText = "";
    this.statusText1 = "";
    this.statusText2 = "";
    this.statusText3 = "";
    this.statusText4 = "";
    this.statusText5 = "";
    this.statusText6 = "";
    this.statusText7 = "";
    this.statusText8 = "";
    this.statusText9 = "";
    this.statusText10 = "";
    this.statusText11 = "";
    this.statusText12 = "";
  }
}
